var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStressGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300.47 125.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-4{fill:#eceff1;}.cls-4{stroke:#fff;}.cls-4,.cls-5{stroke-miterlimit:10;stroke-width:2px;}.cls-5{stroke:#d8dde1;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(1 5.69)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.47,118.32C224.6,118.32,224.6,0,149.73,0S74.87,118.32,0,118.32Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tl_stress_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.47,118.32C224.6,118.32,224.6,0,149.73,0S74.87,118.32,0,118.32",
    transform: "translate(1 5.69)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 49.49,
    y: 5.69,
    width: 42.78,
    height: 118.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 1,
    y: 5.69,
    width: 48.49,
    height: 118.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 122.93,
    width: 54.19,
    height: 124.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 82.32,
    y: 5.69,
    width: 40.75,
    height: 118.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 227.74,
    y: 5.69,
    width: 72.73,
    height: 118.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 177.12,
    y: 5.69,
    width: 50.62,
    height: 118.32
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 300.47,
    y1: 124.01,
    x2: 1,
    y2: 124.01
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressGrey);
export default __webpack_public_path__ + "static/media/stress_grey.080159b30fc4d37339e3c9fe800e9c0c.svg";
export { ForwardRef as ReactComponent };